/* PRIME DIALS theme script — no dependencies. Uses Shopify's AJAX Cart and Section Rendering APIs. */
(() => {
  'use strict';
  const T = window.theme || { routes: { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' }, moneyFormat: '${{amount}}' };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = T.routes.root.endsWith('/') ? T.routes.root : T.routes.root + '/';

  /* ---------- Money ---------- */
  function formatMoney(cents, format = T.moneyFormat) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const fmt = (n, d = 2, t = ',', dec = '.') => {
      if (isNaN(n) || n == null) return 0;
      const parts = (n / 100).toFixed(d).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (parts[1] ? dec + parts[1] : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2);
      }
    });
  }

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 3200);
  }

  /* ---------- Focus helpers ---------- */
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
  let lastFocus = null;
  function trapFocus(container) {
    const handler = (e) => {
      if (e.key !== 'Tab') return;
      const items = $$(FOCUSABLE, container).filter((el) => el.offsetParent !== null);
      if (!items.length) return;
      const first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    container.addEventListener('keydown', handler);
    container._trap = handler;
  }
  function releaseFocus(container) { if (container._trap) container.removeEventListener('keydown', container._trap); }

  function openPanel(panel, opener) {
    if (!panel) return;
    lastFocus = opener || document.activeElement;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    trapFocus(panel);
    const target = $('[data-autofocus]', panel) || $(FOCUSABLE, panel);
    setTimeout(() => target && target.focus(), 60);
  }
  function closePanel(panel) {
    if (!panel || !panel.classList.contains('is-open')) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    releaseFocus(panel);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.drawer.is-open, .mnav.is-open, .search-overlay.is-open').forEach(closePanel);
  });

  /* ---------- Header ---------- */
  function initHeader() {
    const wrap = $('[data-header-wrap]');
    if (!wrap) return;
    const setH = () => document.documentElement.style.setProperty('--header-h', wrap.classList.contains('header-wrap--sticky') ? wrap.offsetHeight + 'px' : '0px');
    setH();
    window.addEventListener('resize', setH, { passive: true });
    const onScroll = () => wrap.classList.toggle('is-scrolled', window.scrollY > 10);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    const mnav = $('[data-mobile-nav]');
    $$('[data-menu-open]').forEach((b) => b.addEventListener('click', () => { openPanel(mnav, b); b.setAttribute('aria-expanded', 'true'); }));
    $$('[data-menu-close]').forEach((b) => b.addEventListener('click', () => { closePanel(mnav); $$('[data-menu-open]').forEach((x) => x.setAttribute('aria-expanded', 'false')); }));

    const search = $('[data-search-overlay]');
    $$('[data-search-open]').forEach((b) => b.addEventListener('click', (e) => { if (!search) return; e.preventDefault(); openPanel(search, b); }));
    $$('[data-search-close]').forEach((b) => b.addEventListener('click', () => closePanel(search)));
  }

  /* ---------- Cart ---------- */
  const drawer = () => $('[data-cart-drawer]');

  function updateCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
      el.classList.add('is-bumped');
      setTimeout(() => el.classList.remove('is-bumped'), 300);
    });
    $$('[data-cart-count-label]').forEach((el) => { el.textContent = count; });
  }

  async function renderDrawer(sectionsHtml) {
    const d = drawer();
    if (!d) return;
    let html = sectionsHtml && sectionsHtml['cart-drawer'];
    if (!html) {
      const res = await fetch(`${root}?sections=cart-drawer`);
      html = (await res.json())['cart-drawer'];
    }
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = $('[data-cart-drawer-inner]', doc);
    const current = $('[data-cart-drawer-inner]', d);
    if (fresh && current) current.replaceWith(fresh);
    const count = parseInt((fresh && fresh.dataset.itemCount) || '0', 10);
    updateCount(count);
  }

  function openCart(opener) {
    if (T.cartType === 'page' || !drawer()) { window.location.href = T.routes.cart; return; }
    openPanel(drawer(), opener);
  }

  async function addToCart(form, button) {
    const errorEl = $('[data-form-error]', form);
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
    button && button.classList.add('is-loading');
    button && button.setAttribute('aria-busy', 'true');
    try {
      const body = new FormData(form);
      body.append('sections', 'cart-drawer');
      body.append('sections_url', window.location.pathname);
      const res = await fetch(`${T.routes.cartAdd}.js`, { method: 'POST', body, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'This item could not be added.');
      await renderDrawer(data.sections);
      const qv = $('#QuickView');
      if (qv && qv.open) qv.close();
      if (T.cartType === 'page') { toast('Added to your bag'); }
      else openCart(button);
    } catch (err) {
      if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
      else toast(err.message);
    } finally {
      button && button.classList.remove('is-loading');
      button && button.removeAttribute('aria-busy');
    }
  }

  async function changeLine(line, quantity) {
    const d = drawer();
    d && d.classList.add('is-busy');
    try {
      const res = await fetch(`${T.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: ['cart-drawer'], sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Your bag could not be updated.');
      if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
      await renderDrawer(data.sections);
      if (data.item_count !== undefined && quantity > 0) {
        const item = data.items[line - 1];
        if (item && item.quantity < quantity) toast(`Only ${item.quantity} available.`);
      }
    } catch (err) {
      toast(err.message);
    } finally {
      d && d.classList.remove('is-busy');
    }
  }

  function initCart() {
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('[data-product-form]');
      if (!form) return;
      e.preventDefault();
      addToCart(form, form.querySelector('[type="submit"]'));
    });
    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-cart-open]');
      if (opener && T.cartType !== 'page' && drawer()) { e.preventDefault(); openCart(opener); return; }
      if (e.target.closest('[data-cart-close]')) { closePanel(drawer()); return; }
      const step = e.target.closest('[data-line-step]');
      if (step) {
        const line = parseInt(step.dataset.line, 10);
        const q = parseInt(step.dataset.qty, 10) + parseInt(step.dataset.lineStep, 10);
        changeLine(line, Math.max(0, q));
        return;
      }
      const rm = e.target.closest('[data-line-remove]');
      if (rm) { e.preventDefault(); changeLine(parseInt(rm.dataset.line, 10), 0); }
    });
    document.addEventListener('change', (e) => {
      const input = e.target.closest('[data-line-input]');
      if (input) changeLine(parseInt(input.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
    });
    // Keep the drawer in sync when returning via the back button (bfcache).
    window.addEventListener('pageshow', (e) => { if (e.persisted) renderDrawer(); });
  }

  /* ---------- Quantity steppers (product forms) ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-step]');
    if (!b) return;
    const input = b.closest('[data-qty]').querySelector('input');
    const next = Math.max(parseInt(input.min || '1', 10), (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product (variants, gallery) ---------- */
  function initProduct(scope) {
    $$('[data-product-root]', scope).forEach((rootEl) => {
      if (rootEl._init) return;
      rootEl._init = true;
      const variants = JSON.parse($('[data-variants]', rootEl).textContent);
      const idInput = $('[data-variant-id]', rootEl);
      const btn = $('[data-add-button]', rootEl);
      const label = $('[data-add-label]', rootEl);
      const avail = $('[data-availability]', rootEl);
      const priceCur = $('[data-price-current]', rootEl);
      const priceCmp = $('[data-price-compare]', rootEl);
      const priceWrap = $('[data-price]', rootEl);
      const fieldsets = $$('[data-option-index]', rootEl);
      const isMain = rootEl.hasAttribute('data-main-product');
      const gallery = rootEl.closest('[data-product-section]') && $('[data-gallery]', rootEl.closest('[data-product-section]'));

      const selected = () => fieldsets.map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });

      const markAvailability = () => {
        const sel = selected();
        fieldsets.forEach((fs, i) => {
          $$('input', fs).forEach((input) => {
            const trial = sel.slice(); trial[i] = input.value;
            const match = variants.find((v) => v.options.every((o, j) => o === trial[j]));
            const lab = input.nextElementSibling;
            if (lab) lab.classList.toggle('is-unavailable', !match || !match.available);
          });
        });
      };

      const update = () => {
        const sel = selected();
        fieldsets.forEach((fs, i) => { const s = $('[data-option-selected]', fs); if (s) s.textContent = sel[i]; });
        const v = variants.find((x) => x.options.every((o, j) => o === sel[j]));
        markAvailability();
        if (!v) {
          btn.disabled = true; label.textContent = 'Unavailable';
          if (avail) avail.innerHTML = '<span class="dot" aria-hidden="true"></span> This combination is unavailable';
          return;
        }
        idInput.value = v.id;
        btn.disabled = !v.available;
        label.textContent = v.available ? 'Add to bag' : 'Sold out';
        if (avail) avail.innerHTML = v.available
          ? '<span class="dot dot--ok" aria-hidden="true"></span> In stock, ready to order'
          : '<span class="dot" aria-hidden="true"></span> Sold out';
        if (priceCur) priceCur.textContent = formatMoney(v.price);
        const onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (priceCmp) { priceCmp.hidden = !onSale; priceCmp.textContent = onSale ? formatMoney(v.compare_at_price) : ''; }
        if (priceWrap) priceWrap.classList.toggle('price--sale', !!onSale);
        if (v.featured_media && gallery) gallery._show && gallery._show(String(v.featured_media.id));
        if (isMain && window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
        const sticky = $('[data-sticky-atc]');
        if (isMain && sticky) {
          const sb = $('button', sticky);
          sb.disabled = !v.available;
          sb.textContent = v.available ? 'Add to bag' : 'Sold out';
          const sp = $('[data-sticky-price]', sticky); if (sp) sp.textContent = formatMoney(v.price);
        }
      };
      fieldsets.forEach((fs) => fs.addEventListener('change', update));
      markAvailability();
    });

    $$('[data-gallery]', scope).forEach((g) => {
      if (g._init) return;
      g._init = true;
      const main = $('[data-gallery-main]', g);
      const mainImg = main && $('img', main);
      const thumbs = $$('[data-gallery-thumb]', g);
      const show = (mediaId) => {
        const t = thumbs.find((x) => x.dataset.mediaId === mediaId);
        if (!t || !mainImg) return;
        thumbs.forEach((x) => x.setAttribute('aria-current', x === t ? 'true' : 'false'));
        main.classList.add('is-switching');
        const img = new Image();
        img.src = t.dataset.src; img.srcset = t.dataset.srcset || '';
        const swap = () => {
          mainImg.src = t.dataset.src;
          mainImg.srcset = t.dataset.srcset || '';
          mainImg.alt = t.dataset.alt || '';
          main.dataset.full = t.dataset.full;
          main.classList.remove('is-switching');
        };
        img.decode ? img.decode().then(swap, swap) : (img.onload = swap);
      };
      g._show = show;
      thumbs.forEach((t) => t.addEventListener('click', () => show(t.dataset.mediaId)));
      if (main) {
        const openLightbox = () => {
          const lb = $('#Lightbox');
          if (!lb) return;
          const img = $('img', lb);
          img.src = main.dataset.full || mainImg.src;
          img.alt = mainImg.alt;
          lb.showModal();
        };
        main.addEventListener('click', openLightbox);
        main.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(); } });
      }
    });
  }

  /* ---------- Quick view ---------- */
  function initQuickView() {
    const modal = $('#QuickView');
    if (!modal) return;
    const body = $('[data-quickview-body]', modal);
    document.addEventListener('click', async (e) => {
      const b = e.target.closest('[data-quick-view]');
      if (!b) return;
      e.preventDefault();
      lastFocus = b;
      body.innerHTML = '<div class="spinner" role="status" aria-label="Loading"></div>';
      modal.showModal();
      try {
        const url = new URL(b.dataset.quickView, window.location.origin);
        url.searchParams.set('view', 'quickview');
        const res = await fetch(url.toString());
        if (!res.ok) throw new Error();
        body.innerHTML = await res.text();
        initProduct(body);
        const first = $(FOCUSABLE, body); first && first.focus();
      } catch {
        body.innerHTML = `<p class="empty-state">This product could not be loaded. <a class="link-arrow" href="${b.dataset.quickView}">View the product</a></p>`;
      }
    });
    $$('[data-modal-close]').forEach((x) => x.addEventListener('click', () => x.closest('dialog').close()));
    $$('dialog').forEach((d) => {
      d.addEventListener('click', (e) => { if (e.target === d) d.close(); });
      d.addEventListener('close', () => { if (lastFocus && lastFocus.focus) lastFocus.focus(); });
    });
  }

  /* ---------- Accordions (smooth height) ---------- */
  function initAccordions() {
    if (reduceMotion) return;
    $$('.accordion details').forEach((d) => {
      const summary = $('summary', d);
      const body = $('.accordion__body', d);
      if (!summary || !body) return;
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        if (d.open) {
          const h = body.scrollHeight;
          body.animate([{ height: h + 'px' }, { height: '0px' }], { duration: 300, easing: 'ease' }).onfinish = () => { d.open = false; };
        } else {
          d.open = true;
          const h = body.scrollHeight;
          body.animate([{ height: '0px' }, { height: h + 'px' }], { duration: 350, easing: 'ease' });
        }
      });
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    const items = $$('[data-reveal]');
    if (reduceMotion || !('IntersectionObserver' in window)) { items.forEach((i) => i.classList.add('is-visible')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach((i) => io.observe(i));
    $$('.hero').forEach((h) => requestAnimationFrame(() => h.classList.add('is-ready')));
  }

  /* ---------- Collection filters / sort / load more ---------- */
  function initFilters() {
    const form = $('[data-filter-form]');
    if (form) {
      let t;
      form.addEventListener('change', (e) => {
        if (window.matchMedia('(max-width: 989px)').matches && !e.target.closest('[data-sort]')) return; // mobile applies via button
        clearTimeout(t);
        t = setTimeout(() => submitFilters(form), e.target.type === 'number' ? 600 : 50);
      });
    }
    $$('[data-sort]').forEach((s) => s.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', s.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }));
    const fd = $('[data-filters-drawer]');
    const mq = window.matchMedia('(min-width: 990px)');
    const syncFd = () => { if (fd) { if (mq.matches) fd.removeAttribute('aria-hidden'); else if (!fd.classList.contains('is-open')) fd.setAttribute('aria-hidden', 'true'); fd.setAttribute('role', mq.matches ? 'region' : 'dialog'); } };
    syncFd(); mq.addEventListener ? mq.addEventListener('change', syncFd) : mq.addListener(syncFd);
    $$('[data-filters-open]').forEach((b) => b.addEventListener('click', () => openPanel(fd, b)));
    $$('[data-filters-close]').forEach((b) => b.addEventListener('click', () => closePanel(fd)));

    const more = $('[data-load-more]');
    if (more) more.addEventListener('click', async () => {
      more.classList.add('is-loading');
      try {
        const res = await fetch(more.dataset.next);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const grid = $('[data-product-grid]');
        $$('[data-product-grid] > *', doc).forEach((c) => { grid.appendChild(c); $$('[data-reveal]', c).concat(c.matches('[data-reveal]') ? [c] : []).forEach((r) => r.classList.add('is-visible')); });
        const nextBtn = $('[data-load-more]', doc);
        const prog = $('[data-load-progress]', doc);
        if (prog) $('[data-load-progress]').replaceWith(prog);
        if (nextBtn) more.dataset.next = nextBtn.dataset.next; else more.remove();
      } catch { toast('More products could not be loaded.'); }
      more.classList.remove('is-loading');
    });
  }
  function submitFilters(form) {
    const params = new URLSearchParams(new FormData(form));
    for (const [k, v] of Array.from(params.entries())) if (v === '') params.delete(k);
    const sort = new URL(window.location.href).searchParams.get('sort_by');
    if (sort) params.set('sort_by', sort);
    window.location.href = `${window.location.pathname}?${params.toString()}`;
  }

  /* ---------- Product recommendations ---------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(async (el) => {
      try {
        const res = await fetch(el.dataset.url);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const inner = $('[data-recommendations]', doc);
        if (inner && inner.innerHTML.trim()) {
          el.innerHTML = inner.innerHTML;
          $$('[data-reveal]', el).forEach((r) => r.classList.add('is-visible'));
        } else el.closest('section') && (el.closest('section').hidden = true);
      } catch { el.closest('section') && (el.closest('section').hidden = true); }
    });
  }

  /* ---------- Recently viewed (stored only in this browser) ---------- */
  function initRecentlyViewed() {
    const KEY = 'pd_recent_v1';
    let list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { list = []; }
    const cur = $('[data-recent-current]');
    if (cur) {
      try {
        const item = JSON.parse(cur.textContent);
        list = [item, ...list.filter((x) => x.handle !== item.handle)].slice(0, 9);
        localStorage.setItem(KEY, JSON.stringify(list));
      } catch { /* storage unavailable */ }
    }
    $$('[data-recently-viewed]').forEach((wrap) => {
      const exclude = wrap.dataset.exclude;
      const items = list.filter((x) => x.handle !== exclude).slice(0, parseInt(wrap.dataset.limit || '4', 10));
      if (!items.length) return;
      const grid = $('[data-recent-grid]', wrap);
      grid.innerHTML = items.map((x) => `
        <article class="card is-visible">
          <a class="card__media ratio--${wrap.dataset.ratio || 'portrait'}" href="${x.url}">
            ${x.image ? `<img class="card__img" src="${x.image}" alt="${x.title.replace(/"/g, '&quot;')}" loading="lazy" width="600" height="750">` : ''}
          </a>
          <div class="card__info"><h3 class="card__title"><a href="${x.url}">${x.title}</a></h3><div class="price">${x.price}</div></div>
        </article>`).join('');
      wrap.hidden = false;
    });
  }

  /* ---------- Sticky mobile add to bag ---------- */
  function initStickyAtc() {
    const bar = $('[data-sticky-atc]');
    const form = $('[data-main-product] [data-product-form]');
    if (!bar || !form || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(([en]) => bar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(form);
    $('button', bar).addEventListener('click', () => addToCart(form, $('button', bar)));
  }

  document.addEventListener('DOMContentLoaded', () => {
    initHeader();
    initCart();
    initProduct(document);
    initQuickView();
    initAccordions();
    initReveal();
    initFilters();
    initRecommendations();
    initRecentlyViewed();
    initStickyAtc();
  });

  // Theme editor support
  document.addEventListener('shopify:section:load', (e) => { initProduct(e.target); initReveal(); initAccordions(); });
})();
